import {
  ContractMasterGroupCodes,
  FieldBuilder,
  FieldDefinition,
} from "@zendra/shared";
import { VendorService } from "cbd-proxies";
import { WoodCertificationService } from "geographic/proxy";
import { BioForestAbpService } from "orchestrator/proxy";

FieldBuilder.setNamespace('Geographic');

export const CERTIFIEDCONTRACTS_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('woodCertificationId', 'Entity.WoodCertification', WoodCertificationService)
    .required()
    .display('name')
    .displayFromNested('woodCertificationName')
    .sortBy('woodCertificationName')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('contractId', 'WoodCertificationDetail.Contract', BioForestAbpService)
    .loadWith((service, query, config) => service.getContracts(query, undefined, config))
    .queryFilter({ contractMasterGroupCode: ContractMasterGroupCodes.Land })
    .display('number')
    .displayFromNested('contractNumber')
    .sortBy('contractNumber')
    .required()
    .build(),
  FieldBuilder.foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .display('fantasyName')
    .displayFromNested('vendorName')
    .sortBy('vendorName')
    .readOnly()
    .build(),
  FieldBuilder
    .date('addedDate', 'Entity.WoodCertificationDetail.AddedDate')
    .required()
    .build()
];

export const CERTIFIEDCONTRACTS_CONFIG = {
  entityName: 'CertifiedContracts',
  localizationKey: 'Geographic::WoodCertificationDetail.CertifiedContracts',
  fields: CERTIFIEDCONTRACTS_FIELDS,
  permission: 'PlanningGeography.WoodCertificationDetails',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
